import './amount.scss';

import { useEffect } from "react";
import { setPurchase } from "../../../store/TransactionSlice";
import { brlFormatter, brlFormatter4Digits, USDTFormatter, USDTFormatter2digits, USDTFormatter4digits } from "../../../utils";
import { useDispatch } from "react-redux";

export const Amount: React.FC<{ value: number, format?: boolean, currency?: string, isReceipt?: boolean, mini?: boolean }> = ({ value, format = true, currency = 'R$', isReceipt = false, mini = false}) => {

    const dispatch = useDispatch();
    
    if(!value) value = 0;

    let amountFormated = '';

    if (currency) {
        if (currency.toLocaleLowerCase() === 'usdt' && mini == false) {
            amountFormated = USDTFormatter
            .format(value)
            .replace('$', '')
        } else if (currency.toLocaleLowerCase() === 'usdt' && mini == true) {
            amountFormated = USDTFormatter2digits
            .format(value)
            .replace('$', '')
        } else if (currency.toLocaleLowerCase() === 'brl' && mini == false) {
            amountFormated = brlFormatter4Digits
            .format(value)
            .replace('R$', '')
        } else {
            amountFormated = brlFormatter
            .format(value)
            .replace('R$', '')
        }
    } else {
        amountFormated = brlFormatter4Digits
        .format(value)
        .replace('R$', '')+""
    }


    const sizes = [
        { threshold: 0, style: 'huge' },
        { threshold: 6, style: 'big' },
        { threshold: 9, style: 'medium' },
        { threshold: 12, style: 'small' },
    ];
    let style = '';
    for (const val of sizes) {
        if (amountFormated.length > val.threshold) style = val.style;
    }

    useEffect(() => {
        dispatch(setPurchase({ value: Number(value) }))
    }, [dispatch, value])

    return (
        <div className={`current-value ${style}`}>
            <span className="lowerTitle">
                {currency} &nbsp; 
            </span>
            <span className='poppins-semibold'>
                { isReceipt ? Number(amountFormated.replace(',','.')) === 0 ? " - - -" : amountFormated : amountFormated }
            </span>
        </div>
    );
};